<template>
	<v-card class="elevation-1" color="white">
		<v-card-title class="secondary--text">
			<v-spacer></v-spacer>

			<v-icon color="secondary" @click="closeOfferSent()">mdi-close</v-icon>
		</v-card-title>
		<v-row no-gutters>
			<v-col>
				<div align="center" justify="center">
					<v-avatar color="white" size="100">
						<img class="white--text align-end" height="30" :src="require('@/assets/icons/✅.svg')" />
					</v-avatar>
				</div>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col>
				<p color="primary--text" class="title" align="center" justify="center">Booking request sent</p>
			</v-col>
		</v-row>

		<v-row no-gutters>
			<v-col>
				<p align="center" class="subtitle primary--text" justify="center">Find Locum</p>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import { bus } from '@/main';
export default {
	name: 'PracticeToLocumBookingRequestSent',
	components: {},
	data: () => ({}),
	methods: {
		closeOfferSent() {
			bus.$emit('change-context', 'dashboard-landing-zone');
		},
	},
};
</script>
